import translations from '../translations';

export const tryGetErrorMessage = (error: unknown) => {
    return error instanceof Error
        ? error.message
        : typeof error === 'string'
          ? error
          : translations.USER_SETTINGS_unknown_error_message;
};
